import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import { TeammoApi, normalize } from 'app/utils/redux/helpers';
import { invitationSchema, enrolmentSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { sagaActions } from 'app/ducks/invitations/actions';
import { InvitationsActionTypes as types } from 'app/ducks/invitations/types';

function* createEnrolmentSaga(action): any {
  yield put(sagaActions.createEnrolmentPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).enrolments.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, enrolmentSchema);

    yield put(sagaActions.createEnrolmentSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(error, sagaActions.createEnrolmentFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
    );
  }
}

function* getInvitationSaga(action): any {
  yield put(sagaActions.getInvitationPending());

  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationInvitations.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, invitationSchema);
    yield put(sagaActions.getInvitationSuccess(normalizedResponse));
    return normalizedResponse.entities.invitations[normalizedResponse.result];
  }
  yield put(handleError(error, sagaActions.getInvitationFailed(_.isEmpty(error) ? {} : error.response.data.errors)));
  return null;
}


/* ********************************* SAGA WATCHERS ********************************* */

function* createEnrolmentSagaWatcher(): any {
  yield takeLatest(types.CREATE_ENROLMENT_REQUESTED, createEnrolmentSaga);
}

function* getInvitationSagaWatcher(): any {
  yield takeEvery(types.GET_INVITATION_REQUESTED, getInvitationSaga);
}


export default function* root(): any {
  yield all([
    createEnrolmentSagaWatcher(),
    getInvitationSagaWatcher(),
  ]);
}
